import { render, staticRenderFns } from "./cp_slogan.vue?vue&type=template&id=239dc588&scoped=true"
import script from "./cp_slogan.vue?vue&type=script&lang=js"
export * from "./cp_slogan.vue?vue&type=script&lang=js"
import style0 from "./cp_slogan.vue?vue&type=style&index=0&id=239dc588&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239dc588",
  null
  
)

export default component.exports